import React from 'react';
import { Box, Checkbox, Divider, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TABLET_BREAKPOINT } from '../../../../Constants/constant';
import KenSelect from '../../../KenSelect';
import { useApplicationContext } from '../../../../Context/applicationContext';

const useStyles = makeStyles((theme) => ({
  li: {
    textAlign: 'left',
    padding: theme.spacing(1),
    paddingLeft: '5px',
  },
}));

const Declaration = (props) => {
  const { applicationState, applicationDispatch } = useApplicationContext();
  const classes = useStyles();
  const theme = useTheme();

  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));

  return (
    <>
      <Box p={2} pb={10} width={isMobileScreen ? '100%' : '80%'} margin="0 auto">
        <Typography fontWeight={600} variant="h4" color="primary" pt={3} align="left" textTransform="uppercase">
          Declaration
        </Typography>
        <Box py={isMobileScreen ? 1 : 3}>
          <Divider />
        </Box>

        <Box pt={0}>
          <Typography fontWeight={500} color="primary" align="left" variant="subtitle2" fontSize={'16px'} sx={{ color: '#000000' }}>
            I Do hereby give an undertaking to abide by the following rules and regulations laid downby the school Management.
          </Typography>
          <ul>
            <li className={classes.li}>We shall co-operate with the school authorities and the concerned class/subject teachers in the development of our child.</li>
            <li className={classes.li}>We understand that misbehaviour with any staff of the school is not acceptable and in such an event, management reserves the right to take any disciplinary action including the withdrawal of admission granted to the child.</li>
            <li className={classes.li}>Communication/Correspondence with the class/subjects teachers will be during school working hours through the Principal/Co-ordinator.</li>
            <li className={classes.li}>Our relationship with all the staff of the school will be courteous and polite at all times.</li>
            <li className={classes.li}>We will respect all school activities to promote our ancient Indian culture and will not object in any way to them.</li>
            <li className={classes.li}>We will visit the school only at the stipulated time for any enquiries related to our child.</li>
            <li className={classes.li}>We will take care not to send mobile phones/iPods,any such electronic gadgets and also see that our child does not wear any valuable ornament. </li>
            <li className={classes.li}>We have no objection to the singing of the National Anthem,Vande Mataram,etc and chanting of shlokas and Bagawad Gita by Our son/daughter. </li>
            <li className={classes.li}>We shall Strictly abide by the school uniform norms irrespective of our individual caste/creed/religion. </li>
            <li className={classes.li}>We understand that our son/daughter must start attending classes within fifteen days of reopening of the school,failing which the admission will be cancelled automatically.We shall intimate and take permission from Management for leave of any sort, before the reopening. </li>
            <li className={classes.li}>We understand that cancellation of admission is not entertained and there is no refund/transfer of fees once paid. </li>
          </ul>
          <KenSelect
            required={true}
            select
            label="Admission process is initiated by"
            value={applicationState.admissionInitiatedBy}
            options={[
              { label: 'Father', value: 'Father' },
              { label: 'Mother', value: 'Mother' },
              { label: 'Both', value: 'Both' },
            ]}
            onChange={(e) => {
              applicationDispatch({ type: 'update', payload: { admissionInitiatedBy: e?.target?.value } });
            }}
          />
          <Grid container mb={2}>
            <Grid item xs={12} sm={12} mt={3} textAlign="left">
              <Box>
                <Checkbox
                  checked={applicationState.formalDeclaration}
                  onChange={(e) => {
                    applicationDispatch({ type: 'update', payload: { formalDeclaration: e?.target?.checked } });
                  }}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
                <span>I Agree</span>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Declaration;
